import request from '@/utils/request'


// 查询步数列表
export function listBook(query) {
  return request({
    url: '/address/book/list',
    method: 'get',
    params: query
  })
}

// 查询步数分页
export function pageBook(query) {
  return request({
    url: '/address/book/page',
    method: 'get',
    params: query
  })
}

// 查询步数详细
export function getBook(data) {
  return request({
    url: '/address/book/detail',
    method: 'get',
    params: data
  })
}

// 新增步数
export function addBook(data) {
  return request({
    url: '/address/book/add',
    method: 'post',
    data: data
  })
}

// 修改步数
export function updateBook(data) {
  return request({
    url: '/address/book/edit',
    method: 'post',
    data: data
  })
}

// 删除步数
export function delBook(data) {
  return request({
    url: '/address/book/delete',
    method: 'post',
    data: data
  })
}
